import { Component, OnInit } from '@angular/core';
import { AuthService } from 'common/services/auth.service';
import { from } from 'rxjs';
import { LanguageService } from './LanguageService/Language.Service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    providers:[LanguageService]
})
export class AppComponent implements OnInit {
    constructor(private authService: AuthService , private LanguageService:LanguageService ) { }

    ngOnInit() {
        this.authService.autoAuthUser();
        // this.LanguageService.LanguageService();
    }
}
